import styled from "styled-components";

interface iInputProps {
  InputLink?: boolean;
}

export const Input = styled.input<iInputProps>`
  padding: ${props => props.InputLink ? 'none' : '14px'};
  border: ${props => props.InputLink ? 'none' : `1px solid ${props.theme.colors.typography1.dark}`};
  margin-bottom: ${props => props.InputLink ? 'none' : '28px'};
  margin-left: ${props => props.InputLink ? '1px' : 'none'};
  border-radius: ${props => props.InputLink ? 'none' : '12px'};;
  background-color: inherit;
  outline: none;
  color: ${(props) => props.theme.colors.typography1.dark};
  font-size: 0.89rem;

  &.inputSearch{
        border: none;
        border-radius: 0;
        margin: 0;
        width: 100%;
        height: 60px;
        /*border-bottom: 1px solid #757575;*/
    }  
  
  &.errorColor {
        border: 1.6px solid  ${props => props.theme.colors.error.pure};
    }

  :focus {
    border: ${props => props.InputLink ?
              'none' : 
              `1.5px solid ${props.theme.colors.brand1.pure};`};
  }

  :disabled {
    cursor: not-allowed;
  }
`;